import { useState, useId } from 'react';
import { Box, Container, Link, Sheet, Stack, Typography } from '@mui/joy';
import { motion, AnimatePresence } from 'framer-motion';
import {
    CaretDown,
} from '@phosphor-icons/react';
import { FadeIn } from './FadeIn';

const FAQ_ITEMS = [
    { q: 'Аквариум бесплатный?', a: 'Да, полностью. Все функции доступны без подписок и скрытых платежей.' },
    { q: 'Нужен ли номер телефона?', a: 'Нет. Для регистрации достаточно электронной почты или аккаунта Яндекса.' },
    { q: 'В чем отличия Аквариума от других мессенджеров и соцсетей?', a: 'Это мессенджер и микроблог в одном месте: чаты, звонки и спокойная лента. Без рекламы и алгоритмов.' },
    { q: 'Мои переписки в безопасности?', a: 'Сообщения хранятся и передаются в зашифрованном виде. Доступ к ним имеете только вы.' },
    { q: 'На каких устройствах работает?', a: 'Веб-версия, iOS и Android. Чаты и лента синхронизируются между всеми устройствами.' },
];

function FaqItem({ q, a }) {
    const [open, setOpen] = useState(false);
    const panelId = useId();
    return (
        <Sheet
            variant="soft"
            sx={{ borderRadius: '20px', backgroundColor: 'rgba(72, 190, 186, 0.07)', overflow: 'hidden' }}
        >
            <Box
                component="button"
                type="button"
                onClick={() => setOpen((v) => !v)}
                aria-expanded={open}
                aria-controls={panelId}
                sx={{
                    all: 'unset',
                    boxSizing: 'border-box',
                    cursor: 'pointer',
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 2,
                    p: { xs: 2.5, md: 3 },
                    '&:focus-visible': {
                        outline: '2px solid var(--joy-palette-primary-500)',
                        outlineOffset: '-2px',
                        borderRadius: '20px',
                    },
                }}
            >
                <Typography level="title-md" sx={{ fontWeight: 600 }}>{q}</Typography>
                <Box
                    sx={{
                        color: 'var(--joy-palette-primary-500)',
                        display: 'flex',
                        transition: 'transform .25s ease',
                        transform: open ? 'rotate(180deg)' : 'none',
                        flexShrink: 0,
                    }}
                >
                    <CaretDown size={20} weight="bold" />
                </Box>
            </Box>
            <AnimatePresence initial={false}>
                {open && (
                    <motion.div
                        id={panelId}
                        role="region"
                        aria-label={q}
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.25, ease: 'easeInOut' }}
                        style={{ overflow: 'hidden' }}
                    >
                        <Typography level="body-md" sx={{ color: 'text.secondary', px: { xs: 2.5, md: 3 }, pb: { xs: 2.5, md: 3 } }}>
                            {a}
                        </Typography>
                    </motion.div>
                )}
            </AnimatePresence>
        </Sheet>
    );
}

export function FaqSection() {
    return (
        <Container maxWidth="md" id="faq" sx={{ scrollMarginTop: '88px' }}>
            <Box sx={{ my: { md: 12, xs: 6 } }}>
                <FadeIn>
                    <Typography
                        level="h2"
                        sx={{ fontWeight: 700, textAlign: 'center', fontSize: { xs: '1.7rem', md: '2.5rem' }, mb: '2rem !important' }}
                    >
                        Частые вопросы
                    </Typography>
                </FadeIn>
                <Stack spacing={2}>
                    {FAQ_ITEMS.map((item, i) => (
                        <FadeIn key={item.q} delay={i * 0.06}>
                            <FaqItem q={item.q} a={item.a} />
                        </FadeIn>
                    ))}
                </Stack>
                <FadeIn>
                    <Box sx={{ textAlign: 'center', mt: 4 }}>
                        <Link href="/faq" level="title-md" sx={{ textDecoration: 'none', fontWeight: 700 }}>
                            Все вопросы и ответы
                        </Link>
                    </Box>
                </FadeIn>
            </Box>
        </Container>
    );
}
